import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import { ProfileContext } from 'context';
import { useAction } from 'hooks';
import Account from 'modules/Account';
import App, { AlertsBus } from 'modules/App';
import { PwdDownloadDataModal } from 'modules/Meter';
import Patient, { ConfirmDataSharingModal, EnrollInClinicModal, InviteFamilyMembersModal, RevokeAccessModal, RevokeFamilyAccessModal } from 'modules/Patient';
import Visit from 'modules/Visit';
import { ConfirmDismissFilteredNotificationsAlert } from 'modules/Notifications';
import * as actions from '../../actions';
import * as selectors from '../../selectors';
import { useIsPinnedMenu } from '../../hooks';
import MainLayout from '../../partials/MainLayout';
import PwdTopBar from './PwdTopBar';
import PwdSidebar from './PatientSidebar';
import ClosePrintModeBtn from './ClosePrintModeBtn';
import styles from './MainLayout.pcss';
const emptySelector = ()=>null;
const profileContext = {
    selectors: {
        activePatient: Account.selectors.patientProfileExtended,
        prvKeyPem: Account.selectors.prvKeyPem,
        passphrase: Account.selectors.passphrase,
        phiSet: Patient.selectors.phiSet,
        phiSetDocumentId: Patient.selectors.phiSetDocumentId,
        readings: Patient.selectors.readings,
        cgmReadings: Patient.selectors.cgmReadings,
        highlightedReadings: Patient.selectors.highlightedReadings,
        measurements: Patient.selectors.measurements,
        measurementsBatchesIndex: Patient.selectors.measurementsBatchesIndex,
        notes: Patient.selectors.notes,
        relatedData: Patient.selectors.relatedData,
        timeSeriesResources: Patient.selectors.timeSeriesResources,
        clinicSettings: emptySelector,
        activeVisit: emptySelector,
        visitHistoryActiveVisit: Visit.selectors.activeVisit
    },
    actions: {
        setReadings: Patient.actions.setReadings,
        storeReadingsSuccess: Patient.actions.onStoreReadingsSuccess
    }
};
const PwdMainLayout = ({ metaTitleMessage, metaDescriptionMessage, isReadOnly, children })=>{
    const isPinnedMenu = useIsPinnedMenu();
    const menuOpen = useSelector(selectors.menuOpen);
    const selectedMenuItem = useSelector(selectors.selectedMenuItem);
    // TODO: Move into child components
    const activeProfileType = useSelector(Account.selectors.activeProfileType);
    const activeProfile = useSelector(Account.selectors.activeProfile);
    const isPatientAccount = useSelector(Account.selectors.isPatientAccount);
    const direction = useSelector(App.selectors.direction);
    const isPrintMode = useSelector(App.selectors.printMode);
    const setMenuOpen = useAction(actions.setMenuOpen);
    const setSelectedMenuItem = useAction(actions.setSelectedMenuItem);
    const closeDropdown = useAction(App.actions.closeDropdown);
    const onClickSidebar = (evt)=>{
        evt.stopPropagation();
        closeDropdown();
    };
    return /*#__PURE__*/ _jsx(MainLayout, {
        metaTitleMessage: metaTitleMessage,
        metaDescriptionMessage: metaDescriptionMessage,
        children: /*#__PURE__*/ _jsxs(ProfileContext.Provider, {
            value: profileContext,
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: cn({
                        [styles.container]: !isPrintMode,
                        [styles.layoutContainer]: !isPrintMode
                    }),
                    children: [
                        /*#__PURE__*/ _jsx(PwdTopBar, {
                            isReadOnly: isReadOnly
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: cn({
                                [styles.layout]: !isPrintMode
                            }),
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: cn({
                                        'row no-gutters': !isPrintMode,
                                        [styles.sidebarContainer]: !isPrintMode
                                    }),
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: cn(styles.sidebarHolder, {
                                                [styles['sidebarHolder--extended']]: isPinnedMenu
                                            }),
                                            onClick: onClickSidebar,
                                            onKeyDown: undefined,
                                            children: /*#__PURE__*/ _jsx("div", {
                                                className: cn('col-auto d-print-none', {
                                                    [styles.hide]: isPrintMode
                                                }),
                                                children: /*#__PURE__*/ _jsx(PwdSidebar, {
                                                    isReadOnly: isReadOnly,
                                                    direction: direction,
                                                    setMenuOpen: setMenuOpen,
                                                    setSelectedMenuItem: setSelectedMenuItem,
                                                    menuOpen: menuOpen,
                                                    selectedMenuItem: selectedMenuItem,
                                                    isPinnedMenu: isPinnedMenu
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(ClosePrintModeBtn, {})
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "content",
                                    children: [
                                        /*#__PURE__*/ _jsx(AlertsBus, {
                                            className: "px-6",
                                            isGlobal: true
                                        }),
                                        /*#__PURE__*/ _jsx(ConfirmDismissFilteredNotificationsAlert, {}),
                                        children
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                isPatientAccount && /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(PwdDownloadDataModal, {}),
                        /*#__PURE__*/ _jsx(EnrollInClinicModal, {}),
                        /*#__PURE__*/ _jsx(ConfirmDataSharingModal, {
                            activeProfileType: activeProfileType,
                            activeProfile: activeProfile
                        }),
                        /*#__PURE__*/ _jsx(RevokeAccessModal, {})
                    ]
                }),
                /*#__PURE__*/ _jsx(InviteFamilyMembersModal, {}),
                /*#__PURE__*/ _jsx(RevokeFamilyAccessModal, {})
            ]
        })
    });
};
export default PwdMainLayout;
